export const messages = {
  en: {
    roomCreatePayFee: {
      title: 'Room Create Fee',
      feeType: 'Fee Type',
      feeItem: 'Fee Item',
      startTime: 'Start Time',
      endTime: 'End Time',
      startMonth: 'Start Month',
      endMonth: 'End Month',
      amount: 'Amount',
      rateCycle: 'Rate Cycle',
      rate: 'Rate',
      rateStartTime: 'Rate Start Time',
      building: 'Building',
      roomState: 'Room State',
      room: 'Room',
      selectFeeType: 'Please select fee type',
      selectFeeItem: 'Please select fee item',
      selectStartTime: 'Please select start time',
      selectEndTime: 'Please select end time',
      selectStartMonth: 'Select start month',
      selectEndMonth: 'Select end month',
      inputAmount: 'Please input amount',
      inputRateCycle: 'Please input rate cycle (month)',
      inputRate: 'Please input rate',
      selectRateStartTime: 'Please select rate start time',
      selectBuilding: 'Please select building',
      selectAll: 'Select All',
      noRoom: 'No Room',
      validateError: 'Validation failed',
      noRoomSelected: 'No room selected',
      quickSelect: 'Quick Select',
      quickSelectTitle: 'Quick Select Rooms',
      quickTailTip: 'Click on room number tails to batch select all rooms with the same tail.',
      quickSelectPreview: 'Preview',
      roomUnit: 'rooms',
      clearSelection: 'Clear',
      quickSelectApply: 'Apply',
      occupied: 'Occupied',
      delivered: 'Delivered',
      decorated: 'Decorated',
      vacant: 'Vacant',
      unsold: 'Unsold',
      rented: 'Rented',
      sold: 'Sold',
      billMonth: 'Bill Mode',
      billMonthTip: 'Will generate ',
      billMonthTipSuffix: ' monthly bills',
      mergeMode: 'Smart Merge (Utilities)'
    }
  },
  zh: {
    roomCreatePayFee: {
      title: '房屋创建费用',
      feeType: '费用类型',
      feeItem: '收费项目',
      startTime: '计费起始时间',
      endTime: '计费结束时间',
      startMonth: '开始月份',
      endMonth: '结束月份',
      amount: '收费金额',
      rateCycle: '递增周期',
      rate: '计费递增率',
      rateStartTime: '递增开始时间',
      building: '楼栋',
      roomState: '房屋状态',
      room: '房屋',
      selectFeeType: '请选择费用类型',
      selectFeeItem: '请选择收费项目',
      selectStartTime: '请选择计费起始时间',
      selectEndTime: '请选择计费结束时间',
      selectStartMonth: '请选择开始月份',
      selectEndMonth: '请选择结束月份',
      inputAmount: '请输入收费金额',
      inputRateCycle: '请输入递增周期(月份)',
      inputRate: '请输入递增率',
      selectRateStartTime: '请选择递增开始时间',
      selectBuilding: '请选择楼栋',
      selectAll: '全选',
      noRoom: '没有房屋',
      validateError: '验证失败',
      noRoomSelected: '未包含房屋',
      quickSelect: '快捷勾选',
      quickSelectTitle: '快捷勾选房屋',
      quickTailTip: '点击尾号按钮批量勾选该尾号的所有房间，可多选。',
      quickSelectPreview: '预览',
      roomUnit: '间',
      clearSelection: '清空',
      quickSelectApply: '应用勾选',
      occupied: '已入住',
      delivered: '已交房',
      decorated: '已装修',
      vacant: '未入住',
      unsold: '未销售',
      rented: '已出租',
      sold: '已出售',
      billMonth: '账单模式',
      billMonthTip: '将生成 ',
      billMonthTipSuffix: ' 条月度账单',
      mergeMode: '智能合并（已有费用不重复创建）'
    }
  }
}